import type { LabTestFilters, StatusCountsFilters } from "./labTests";
import type { ProcessingTestFilters } from "./processingTests";
import type { ProjectSearchFilters, ProjectTestsSummaryFilters } from "./projects";

export const queryKeys = {
  allLabTests: ["labTests"] as const,
  labTests: (filters: LabTestFilters) => ["labTests", filters] as const,
  labTestsAll: (filters: LabTestFilters) => ["labTests", "all", filters] as const,
  allStatusCounts: ["statusCounts"] as const,
  statusCounts: (filters: StatusCountsFilters) => ["statusCounts", filters] as const,
  allProcessingTests: (filters: ProcessingTestFilters) => ["allProcessingTests", filters] as const,
  allProcessingTestsList: ["processingTests"] as const,
  processingTests: (filters: ProcessingTestFilters) => ["processingTests", filters] as const,
  projectTestsSummaries: (filters: ProjectTestsSummaryFilters) => ["projectTestsSummaries", filters] as const,
  projectSearch: (filters: ProjectSearchFilters) => ["projectSearch", filters] as const,
  externalProjectLookup: (contract: string) => ["externalProjectLookup", contract] as const,
  project: (projectId: string) => ["project", projectId] as const,
  reportContainers: (projectId: string) => ["reportContainers", projectId] as const,
  reportCoverage: (projectId: string) => ["reportCoverage", projectId] as const,
  reportContainer: (projectId: string, containerId: string) => ["reportContainers", projectId, containerId] as const,
  reportContainerTests: (projectId: string, containerId: string) =>
    ["reportContainers", projectId, containerId, "tests"] as const,
  reportContainerReports: (projectId: string, containerId: string) =>
    ["reportContainers", projectId, containerId, "reports"] as const,
  laboratories: () => ["laboratories"] as const,
  labPermissions: (laboratoryId: string) => ["labPermissions", laboratoryId] as const,
  laboratoryManagers: () => ["laboratoryManagers"] as const,
  labTest: (testId: string) => ["labTest", testId] as const,
  relatedTests: (testId: string) => ["relatedTests", testId] as const,
  reuseCandidates: (testId: string, quantity: string) => ["reuseCandidates", testId, quantity] as const,
  processingTestBundle: (testId: string) => ["processingTestBundle", testId] as const,
  batchProcessingTestData: (ids: string[]) => ["batchProcessingTestData", ids] as const,
  laboratorySettings: (laboratoryId: string) => ["laboratorySettings", laboratoryId] as const,
  auditLog: (scope: "test" | "processing-test", id: string) => ["auditLog", scope, id] as const,
  attachment: (testId: string, fileName: string) => ["attachment", testId, fileName] as const,
  userPermissions: (email: string) => ["userPermissions", email] as const,
  projectSamples: (goldenRecordId: string, location: string) => ["projectSamples", goldenRecordId, location] as const,
  allProjectSamples: (goldenRecordId: string) => ["allProjectSamples", goldenRecordId] as const,
  projectLocations: (goldenRecordId: string) => ["projectLocations", goldenRecordId] as const,
  testConditions: (testId: string) => ["testConditions", testId] as const,
  testConditionsList: (projectId: string, type: string) => ["testConditions", "list", projectId, type] as const,
  uuProject: (goldenRecordId: string) => ["uuProject", goldenRecordId] as const,
};
